import { render, staticRenderFns } from "./orderMoneyBack.vue?vue&type=template&id=15cca62b"
import script from "./orderMoneyBack.vue?vue&type=script&lang=js"
export * from "./orderMoneyBack.vue?vue&type=script&lang=js"
import style0 from "./orderMoneyBack.vue?vue&type=style&index=0&id=15cca62b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports